import React, { useState, useEffect } from 'react'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'

import StyledTable from '../../components/ReactTable/StyledTable'
import StyledTableContainer from '../../components/StyledTableContainer/StyledTableContainer'
import StyledEmptyHeader from '../../components/StyledEmptyHeader/StyledEmptyHeader'
import rejectionReasonFIService from '../../service/rejectionReasonFI.service'
import StyledSelectField from '../../components/StyledSelectField/StyledSelectField'
import AddFiRejectionReasonModal from './AddFiRejectionReasonModal'

import { showNotification } from '../../utils/toast.utils'
import machineService from '../../service/machine.service'

const RejectionReasonTable = () => {
  const defaultMachine = {
    label: 'FI',
    value: 'FI'
  }

  const [selectedMachine, setSelectedMachine] = useState(defaultMachine)
  const [machineOptions, setMachineOptions] = useState([])
  const [reasons, setReasons] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isAddReasonModalOpen, setIsAddReasonModalOpen] = useState(false)
  const [refetchCount, setRefetchCount] = useState(1)

  useEffect(() => {
    const fetchMachineOptions = async () => {
      try {
        const response = await machineService.getMachines()
        if (response.success) {
          const options = response.data.map((item) => ({
            value: item.name,
            label: item.name
          }))
          setMachineOptions([...options])
        } else {
          showNotification('Failed to fetch machines', 'error')
        }
      } catch (error) {
        console.error('Error fetching machines:', error)
        showNotification('Error fetching machines', 'error')
      }
    }

    fetchMachineOptions()
  }, [])

  useEffect(() => {
    const fetchReasons = async () => {
      setIsLoading(true)
      try {
        const response = await rejectionReasonFIService.getRejectionReasonsFI()
        setReasons(response.data)
      } catch (error) {
        console.error('Error fetching reasons:', error)
        setReasons([])
      } finally {
        setIsLoading(false)
      }
    }
    fetchReasons()
  }, [refetchCount])

  const onSaveRejectionReasonsSuccess = () => {
    setRefetchCount((prev) => prev + 1)
  }

  const searchObj = {
    ...(selectedMachine.value &&
      selectedMachine.value !== 'all' && {
        machine: selectedMachine.value
      })
  }

  let filteredReasons = reasons
  if (Object.keys(searchObj).length > 0) {
    filteredReasons = reasons.filter((row) => {
      return Object.keys(searchObj).every((key) => searchObj[key] === row[key])
    })
  }
  const reasonsTableColumns = [
    {
      Header: 'Machine',
      accessor: 'machine'
    },
    {
      Header: 'Reason',
      accessor: 'reason'
    }
  ]

  return (
    <>
      <Stack
        sx={{
          position: 'sticky',
          top: 0,
          width: '100%',
          flexDirection: 'column',
          gap: '12px',
          borderBottom: '1px solid #eeeeee',
          backgroundColor: '#fff',
          padding: '12px 16px',
          zIndex: 100
        }}
      >
        <Stack
          sx={{
            flexDirection: 'row',
            gap: '16px'
          }}
        >
          <Button
            sx={{
              textTransform: 'none',
              color: '#fff'
            }}
            variant="contained"
            onClick={() => setIsAddReasonModalOpen(true)}
          >
            Add reasons
          </Button>
          <Stack
            sx={{
              width: '250px',
              justifyContent: 'flex-end'
            }}
          >
            <StyledSelectField
              label=""
              placeHolderText="Select machine"
              selectedValue={selectedMachine}
              selectOptions={machineOptions}
              onChangeHandler={(value) => setSelectedMachine(value)}
              isMulti={false}
              isSearchable={true}
              isDisabled={false}
              noOptionsMessage="No machine found"
            />
          </Stack>
        </Stack>
      </Stack>
      <StyledTableContainer>
        {isLoading && <StyledEmptyHeader>Loading...</StyledEmptyHeader>}
        {!isLoading && filteredReasons.length === 0 && (
          <StyledEmptyHeader>No matching reasons found</StyledEmptyHeader>
        )}
        {!isLoading && filteredReasons.length > 0 && (
          <StyledTable
            pagination={false}
            columns={reasonsTableColumns}
            data={filteredReasons}
            hiddenColumns={['id']}
          />
        )}
      </StyledTableContainer>
      {isAddReasonModalOpen && (
        <AddFiRejectionReasonModal
          closeHandler={() => setIsAddReasonModalOpen(false)}
          isModalOpen={isAddReasonModalOpen}
          onSaveSuccess={onSaveRejectionReasonsSuccess}
        />
      )}
    </>
  )
}

export default RejectionReasonTable
